import { render, staticRenderFns } from "./ItemTypeDialog.vue?vue&type=template&id=c75b9a54"
import script from "./ItemTypeDialog.vue?vue&type=script&lang=js"
export * from "./ItemTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports